import React from "react";
import "../../styles/BecomeDriver.css";
import { Container, Row, Col } from "reactstrap";

import driverImg from "../../assets/images/toyota-offer-3.png";

const BecomeDriver = () => {
  return (
    <section className="become__driver">
      <Container>
        <Row>
          <Col lg="6" md="6" sm="12" className="become__driver-img">
            <img src={driverImg} alt="" className="w-100" />
          </Col>

          <Col lg="6" md="6" sm="12">
            <h2 className="section__title become__driver-title">
              We know how to win people's hearts
            </h2>

            <button className="btn become__driver-btn mt-4">
              Become a Driver
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BecomeDriver;